import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

export default function Nav() {
  const { user, logout } = useAuth();
  return (
    <header className="border-b border-slate-200 bg-white/80 backdrop-blur sticky top-0 z-30" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
          <div className="w-8 h-8 rounded-lg bg-[#1E3A8A] text-white grid place-items-center font-bold">P</div>
          <span className="font-bold text-lg text-slate-900">Powerhouse Refunds</span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-4">
          <Link to="/playbooks" className="text-sm text-slate-600 hover:text-slate-900 hidden sm:inline" data-testid="nav-playbooks-link">Playbooks</Link>
          {user ? (
            <>
              <Link to="/dashboard" className="text-sm text-slate-600 hover:text-slate-900 hidden sm:inline" data-testid="nav-dashboard-link">Cases</Link>
              <Link to="/referrals" className="text-sm text-slate-600 hover:text-slate-900 hidden sm:inline" data-testid="nav-referrals-link">Referrals</Link>
              <Button variant="ghost" onClick={logout} data-testid="nav-logout-button">Log out</Button>
            </>
          ) : (
            <Link to="/auth" data-testid="nav-signin-link">
              <Button variant="outline" className="rounded-full">Sign in</Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
